import { Box } from "@mui/material";
import { useOnMobile } from "@core/hooks/useOnMobile";

interface LogoProps {
    size?: number;
    onClick?: () => void;
}

export default function LogoImageOnly({ size, onClick }: LogoProps) {
    const onMobile = useOnMobile();
    // Calculate default size based on device
    const defaultSize = onMobile ? 60 : 80;
    // Use provided size or default
    const finalSize = size ?? defaultSize;
    
    const height = Math.round(finalSize);

    return (
        <Box 
            sx={{ 
                display: 'inline-flex',
                alignItems: 'center',
                cursor: "pointer",
                // Ensure the box doesn't cause layout shifts
                width: finalSize,
                height: height,
                // Center the SVG within the box
                justifyContent: 'center'
            }}
            onClick={onClick}
        >
            <svg 
                id="Ebene_1" 
                data-name="Ebene 1" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 341.61 341.61"
                width="100%"
                height="100%"
                preserveAspectRatio="xMidYMid meet"
            >
                <defs>
                    <style>
                        {`.cls-1 {
                            fill: #28322e;
                        }
                        .cls-2 {
                            fill: #167f58;
                        }`}
                    </style>
                </defs>
                <g>
                    <rect className="cls-2" x="0" y="173.43" width="27" height="71.65" rx="13.5" ry="13.5"/>
                    <rect className="cls-2" x="285.81" y="173.43" width="27" height="71.65" rx="13.5" ry="13.5"/>
                    <path className="cls-2" d="M266.23,107.62H46.58c-17.63,0-31.92,14.29-31.92,31.92v132.95c0,17.63,14.29,31.92,31.92,31.92h10.54c6.44,0,11.69,5.15,11.82,11.58l.18,8.81c.25,12.23,12.88,20.26,24.07,15.3l78.11-34.68c1.51-.67,3.15-1.02,4.8-1.02h90.14c17.63,0,31.92-14.29,31.92-31.92v-132.95c0-17.63-14.29-31.92-31.92-31.92ZM121.03,151.62c9.43,0,17.07,13.48,17.07,30.12s-7.64,30.12-17.07,30.12-17.07-13.48-17.07-30.12,7.64-30.12,17.07-30.12ZM115.54,251.32h80.16c3.5,0,4.99,4.46,2.19,6.55-15.66,11.71-52.12,32.12-84.89-.29-2.33-2.3-.74-6.26,2.53-6.26ZM192.82,211.85c-9.43,0-17.07-13.48-17.07-30.12s7.64-30.12,17.07-30.12,17.07,13.48,17.07,30.12-7.64,30.12-17.07,30.12Z"/>
                    <path className="cls-2" d="M136,30.47C118.35,15.68,95,5.06,83.61.39c-3.35-1.38-7.03,1.07-7.06,4.69-.13,16.21,1.65,54.84,20.56,70.69,17.75,14.88,39.02,22.75,49.12,25.9,3.1.96,6.29-1.19,6.58-4.42,1.28-14.43,2.36-50.69-16.82-66.77ZM116.04,57.53c-7.57-10.68-14.93-21.49-21.55-32.79-.54-.92.71-1.81,1.41-1.01,8.56,9.91,16.41,20.36,24.07,30.98,7.59,10.69,14.96,21.51,21.58,32.83.54.92-.71,1.81-1.41,1.01-8.57-9.92-16.44-20.39-24.1-31.02Z"/>
                    <path className="cls-2" d="M172.42,56.08c-7.77,16.01-9.73,33.31-10.22,41.66-.16,2.69,2.2,4.82,4.86,4.4,11.32-1.82,38.47-7.92,46.9-25.28,7.73-15.93,11.33-35.29,12.73-44.89.43-2.95-2.25-5.41-5.15-4.7-12.43,3.04-40.82,11.7-49.12,28.81ZM192.55,70.65c-5.5,6.78-11.15,13.41-17.31,19.61-.71.71-1.83-.19-1.29-1.04,4.74-7.33,10.02-14.26,15.47-21.08,5.5-6.76,11.14-13.38,17.28-19.57.71-.71,1.84.19,1.29,1.04-4.74,7.31-10.01,14.23-15.45,21.05Z"/>
                </g>
            </svg>
        </Box>
    );
}
